export const selectAvailableLanguages = ({ trsc }) => trsc.languages;



// WEBPACK FOOTER //
// ./redux/selectors/trscService.js